<template>
    <div class="ix-menu-right-item first ix-menu-notification-item">
        <button @click="getNotifications()">
            <i class="far fa-bell"></i>
        </button>

        <span class="ix-menu-notification-item-badge" v-if="nbNotification != 0">{{ nbNotification > 99 ? '99+' : nbNotification }}</span>

        <div class="ix-notifications-panel" id="ix-notifications-panel">
            <div class="ix-notifications-panel-header">
                <h3 class="ix-notifications-panel-title">Notifications</h3>

                <button @click="markAllAsRead()" :disabled="loadingMarkAll" v-b-tooltip title="Marquer comme lu" class="ix-notifications-panel-action">
                    <span v-if="!loadingMarkAll"><i class="far fa-check-double"></i></span>
                    <span v-if="loadingMarkAll"><i class="far fa-circle-notch fa-spin"></i></span>
                </button>
            </div>

            <div class="ix-notifications-panel-content">
                <div v-for="(notification, index) in notifications" :key="index" class="ix-notifications-panel-item">
                    <span class="ix-notifications-round"></span>
                    <span class="ix-notifications-panel-item-left">
                        <a :href="'/notifications/' + notification.id" class="ix-notifications-panel-item-message">{{ notification.data['message'] }}</a>
                        <span class="ix-notifications-panel-item-date">
                            {{ notification.created_at | formatDate('DD MMMM YYYY à HH:mm') }}
                        </span>
                    </span>
                    <span class="ix-notifications-panel-item-right">
                        <button @click="markAsRead(notification, index)" v-b-tooltip title="Marquer comme lu" class="ix-notifications-panel-action bordered">
                            <i class="far fa-check"></i>
                        </button>
                    </span>
                </div>

                <div class="ix-comments-loader" v-if="loading">
                    <i class="far fa-circle-notch fa-spin"></i> Récupération des notifications en cours
                </div>

                <div v-if="notifications && notifications.length == 0 && !loading" class="ix-text-secondary ix-text-small text-center">
                    Pas de nouvelles notifications
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'UserNotification',
        props: {
            userId : null,
            url : '',
        },
        data(){
            return {
                loading: false,
                loadingMarkAll: false,

                nbNotification: 0,
                notifications: [],
            }
        },
        methods: {
            closePanel(){
                $('#ix-notifications-panel').removeClass('open')
            },
            getNotifications(){
                $('#ix-notifications-panel').toggleClass('open')

                if ($('#ix-notifications-panel').hasClass('open')) {
                    this.loading = true;
                    this.notifications = []

                    fetch(this.url + '/unread' ,{
                        ...{
                            method: 'GET'
                        },
                        ...this.getHttpJsonRequestHeaders(),
                    }).then((response) => {
                        if (response.status == 200) {
                            response.json().then((data) => {
                                this.notifications = data;
                                this.nbNotification = data.length;
                            })
                        }
                        this.loading = false;
                    }).catch((error) => {
                        console.log(error)
                        this.loading = false;
                    });
                }
            }, 
            async markAllAsRead(){
                this.loadingMarkAll = true
                 fetch(this.url + '/read' ,{
                ...{
                    method: 'PUT'
                },
                ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    this.loadingMarkAll = false

                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.notifications = [];
                            this.nbNotification = 0;

                            this.closePanel()
                        })
                    }
                }).catch((error) => {
                    this.loadingMarkAll = true
                    console.log(error)
                });
            },
            async markAsRead(notification, index){
                this.notifications.splice(index, 1);
                this.nbNotification --;

                fetch(this.url + '/' + notification.id + '/read' ,{
                    ...{
                        method: 'PUT'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            if (response.status != 200) {
                                this.notifications.splice(2, 0, notification)
                                this.nbNotification ++;
                            }
                        })
                    }
                }).catch((error) => {
                    console.log(error)
                });
            },
            async destroy(notification , index){
                this.notifications.splice(index, 1);
                this.nbNotification --;

                fetch(this.url + '/' + notification.id ,{
                    ...{
                        method: 'DELETE'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status != 200) {
                        this.notifications.splice(2, 0, notification)
                        this.nbNotification ++;
                    }
                }).catch((error) => {
                    console.log(error)
                });
            }
        },
        async mounted(){
            fetch(this.url + '/count' ,{
                ...{
                method: 'GET'
            },
            ...this.getHttpJsonRequestHeaders(),
            }).then((response) => {
                  if (response.status == 200) {
                    response.json().then((data) => {
                       this.nbNotification = data;
                    })
                }
            }).catch((error) => {
                console.log(error)
            });
        }
    }
</script>